import styled from 'styled-components/macro';

import { BlockError } from './BlockError';
import { getErrorCode } from './getErrorCode';

export interface SectionErrorProps {
  // biome-ignore lint/suspicious/noExplicitAny: TODO: fix
  error: any;
}

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 75vh;
`;

// biome-ignore lint/suspicious/noExplicitAny: TODO: fix
function getErrorMessage(error: any) {
  switch (getErrorCode(error)) {
    case 404:
      return 'Error, section not found';
    default:
      return 'Error, something went wrong';
  }
}

/** Designed to be the section content when an error occurs. */
export function SectionError({ error }: SectionErrorProps) {
  return (
    <StyledContainer>
      <BlockError message={getErrorMessage(error)} />
    </StyledContainer>
  );
}
